const validate = (attrs) => {
  const errors = {};
  if (!attrs.showProfile) {
    if (!attrs.nombre) {
      errors.nombre = 'Debe ingresar el nombre';
    }
    if (!attrs.apellido) {
      errors.apellido = 'Debe ingresar el apellido';
    }
    if (!(attrs.numeroDocumento
      && attrs.numeroDocumento.length >= 6
      && /^[0-9]*$/i.test(attrs.numeroDocumento))) {
      errors.numeroDocumento = 'El número de documento no es correcto';
    }
  }

  if (!(attrs.nacionalidad && attrs.nacionalidad.value)) {
    errors.nacionalidad = 'Debe ingresar el país de nacimiento';
  }

  if (!attrs.photoName) {
    errors.photoName = 'Debe ingresar una foto';
  }

  if (!attrs.domicilioTelefono || attrs.domicilioTelefono.length < 6
    || !(/^[+]{0,1}[(]{0,1}[0-9]{1,6}[)|-]{0,1}[ ]{0,1}[/0-9]*$/i.test(attrs.domicilioTelefono))) {
    errors.domicilioTelefono = 'El número de teléfono no es correcto';
  }

  if (attrs.trabajoTelefono
    && !(attrs.trabajoTelefono.length >= 6
      && /^[+]{0,1}[(]{0,1}[0-9]{1,6}[)|-]{0,1}[ ]{0,1}[/0-9]*$/i.test(attrs.trabajoTelefono))) {
    errors.trabajoTelefono = 'El número de teléfono no es correcto';
  }

  if (!attrs.email) {
    errors.email = 'Debe ingresar el correo electrónico.';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(attrs.email)) {
    errors.email = 'El correo electronico no es valido.';
  }

  if (attrs.showProfile) {
    if (!attrs.emergenciaNumero || attrs.emergenciaNumero.length < 6
      || !(/^[+]{0,1}[(]{0,1}[0-9]{1,6}[)|-]{0,1}[ ]{0,1}[/0-9]*$/i.test(attrs.emergenciaNumero))) {
      errors.emergenciaNumero = 'El número de teléfono no es correcto';
    }
    if (!attrs.emergenciaContacto) {
      errors.emergenciaContacto = 'Debe ingresar el nombre del contacto';
    }
  } else if (!(attrs.esAdmin || attrs.esProfesor || attrs.esFuncionario || attrs.esAlumno)) {
    errors.esAdmin = 'Debe seleccionar al menos un rol';
  }

  if (attrs.esProfesor && attrs.categoriasProfesores && attrs.categoriasProfesores.length > 0) {
    const materias = attrs.categoriasProfesores.filter(o => !o.removed && o.materia.value > 0)
      .map(({ materia: { value, label } }) => ({ value, label }));

    const duplicate = materias.find((mat, index) => index !== materias.map(m => m.value).indexOf(mat.value));
    if (duplicate) {
      errors.categoriasProfesores = { _error: `La materia ${duplicate.label} ya fue agregada.` };
    } else {
      attrs.categoriasProfesores.filter(o => !o.removed).forEach(({ materia, escalafon, notas }, index) => {
        const error = {};
        if (!materia || !materia.value) {
          error.materia = 'Debe ingresar una materia';
        }
        if (!escalafon || !escalafon.value) {
          error.escalafon = 'Debe ingresar un escalafón';
        }
        if (!notas || !notas) {
          error.notas = 'Debe ingresar una nota';
        }

        if (Object.keys(error).length) {
          if (!errors.categoriasProfesores) {
            errors.categoriasProfesores = [];
          }

          errors.categoriasProfesores[index] = error;
        }
      });
    }
  }

  errors.isValid = Object.keys(errors).length === 0;

  return errors;
};

export default validate;
